"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const getById = (0, graphql_tag_1.default)`
  query digests_getById($digestId: Int) {
    digests {
      getById(digestId: $digestId) {
        id
        title
        topImage
        periodStart
        periodEnd
        sections {
          section
          subSections {
            subSection
            priority
            subSectionDate
            context
          }
        }
        next {
          id
          shortTitle
        }
        previous {
          id
          shortTitle
        }
      }
    }
  }
`;
exports.default = getById;